<template>
  <div class="transfer-wrapper">
    <div class="transfer__left">
      <div class="left__header">
        <slot name="left-header" />
      </div>
      <div
        v-loading="loading"
        class="transfer__origin"
      >
      <el-checkbox  @change="selectionAll(leftCheckedText)">{{ leftCheckedText}}</el-checkbox>
        <el-checkbox-group v-model="leftChecked">
          <el-checkbox
            v-for="(item, index) in leftData"
            :label="item[props.key]"
            :key="item[props.key]"
            class="block"
          >
            <slot
              :option="item"
              :index="index"
            >{{ item[props.label] }}</slot>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="transfer-button">
      <!--<el-button
        type="primary"
        plain
        icon="el-icon-arrow-left"
        @click="selectionAll()"
      >全选</el-button>-->
       <el-button
        type="primary"
        plain
        @click="add()"
      >
        添加全部
        <i class="el-icon-d-arrow-right el-icon--right" />
      </el-button>
      <el-button
        type="primary"
        plain
        @click="add(true)"
      >
        添加
        <i class="el-icon-arrow-right el-icon--right" />
      </el-button>
      <!--<el-button
        type="primary"
        plain
        icon="el-icon-arrow-left"
        @click="removeSelect()"
      >清除选择</el-button>-->
      <el-button
        type="primary"
        plain
        icon="el-icon-arrow-left"
        @click="remove(true)"
      >移除</el-button>
      <el-button
        type="primary"
        plain
        icon="el-icon-d-arrow-left"
        @click="remove()"
      >移除全部</el-button>
    </div>
    <div class="transfer__right">
      <div class="right__header">
        <slot name="right-header" />
      </div>
      <base-table
        :data="rightData"
        :columns="tableColumns"
        :pagination="false"
        width="100%"
        :max-height="350"
        class="transfer__table"
        v-bind="$attrs"
        v-on="$listeners"
        @selection-change="selectionChange"
      ></base-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransferTable',

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default () {
        return {
          key: 'id',
          label: 'label'
        }
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    loading: Boolean,
    query: {
      type: Object,
      default () {
        return {}
      }
    },
    filterable: Boolean,
    filterMethod: Function,
    reserveSelection: Boolean,
    rowKey: String
  },

  computed: {
    tableColumns () {
      return [
        {
          type: 'selection'
        }
      ].concat(this.columns)
    },
    leftData () {
      return this.data.filter(item => {
        const key = this.rowKey || this.props.key
        const value = item[ key ]
        const isFilter = this.filterable && this.filterMethod ? this.filterMethod(this.query, item) : true
        return !(this.rowKey ? this.value.includes(value) : this.value.some(target => target[ key ] === value)) && isFilter
      })
    },
    rightData () {
      const key = this.rowKey || this.props.key
      const data = this.reserveSelection ? this.selectedRows : this.data
      return data.filter(item => this.rowKey ? this.value.includes(item[ key ]) : this.value.some(target => target[ key ] === item[ key ]))
    }
  },

  watch: {
    data (value) {
      if (this.reserveSelection) return
      const key = this.rowKey || this.props.key
      const val = this.value.filter(item => value.some(target => target[ key ] === (this.rowKey ? item : item[ key ])))
      this.handlerInput(val)
    }
  },

  data () {
    return {
      leftCheckedText:'全选',
      leftChecked: [],
      rightChecked: [],
      selectedRows: []
    }
  },

  methods: {
    handlerInput (value) {
      if (Array.isArray(value)) {
        this.$emit('input', value)
      } else {
        throw new Error('emit value must be an array.')
      }
    },
    remove (checked) {
      // 如果右侧的数据中存在已选中的项，排除它；仅保留未选中的数据
      const key = this.rowKey || this.props.key
      const value = checked ? this.value.filter(value => {
        const val = this.rowKey ? value : value[ key ]
        return !this.rightChecked.some(item => item[ key ] === val)
      }) : []
      this.handlerInput(value)
      this.rightChecked = []
      this.selectedRows = this.selectedRows.filter(item => this.rowKey ? value.includes(item[ key ]) : value.some(target => target[ key ] === item[ key ]))
    },
    
    selectionAll(text){
      if(text=='全选'){
        const key = this.rowKey || this.props.key
        this.leftChecked= this.leftData.map(item => item[key])
        this.leftCheckedText='取消全选'
      }else{
        this.leftChecked=[];
        this.leftCheckedText='全选'
      }
      //获取全部的KEY
   
    
    },
    add (checked) {
      const { key } = this.props
      let result = [ ...this.value ]
      if (checked) {
        for (const value of this.leftChecked) {
          if (this.rowKey ? result.includes(value) : result.some(item => item[ key ] === value)) continue
          result.push(this.rowKey ? value : this.data.find(item => item[ key ] === value))
        }
      } else {
        for (const item of this.data) {
          if (this.rowKey ? result.includes(item[ this.rowKey ]) : result.some(target => target[ key ] === item[ key ])) continue
          result.push(this.rowKey ? item[ this.rowKey ] : item)
        }
      }
      if (this.reserveSelection) {
        this.selectedRows = result.reduce((arr, value) => {
          const key = this.rowKey || this.props.key
          const _value = this.rowKey ? value : value[ key ]
          if (arr.some(item => item[ key ] === _value)) return arr
          const val = this.data.find(item => item[ key ] === _value)
          val && arr.push(val)
          return arr
        }, [ ...this.selectedRows ])
      }
      this.handlerInput(result)
      this.leftChecked = []
    },
    selectionChange (value) {
      this.rightChecked = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .transfer-wrapper {
    display: flex;
    color: $--color-text-primary;
  }
  .transfer__left {
    flex: 1;
    min-width: 530px;
    max-width: 50%;
  }
  .transfer__right {
    flex: 1;
    width: 0 !important;
  }
  .transfer {
    /deep/ {
      .el-transfer__buttons,
      .el-transfer__buttons + .el-transfer-panel,
      .el-transfer-panel__header {
        display: none !important;
      }
      .el-transfer-panel__list {
        padding: 10px 0;
        .el-transfer-panel__item {
          display: block;
        }
        .el-checkbox__label {
          font-size: 12px;
        }
      }
    }
  }
  .transfer__table {
    padding-top: 10px;
  }
  .transfer-button {
    margin: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 90px;
    /deep/ {
      .el-button {
        padding: 7px 10px;
        width: 100%;
        & + .el-button {
          margin-left: 0;
          margin-top: 10px;
        }
      }
    }
  }
  .transfer__origin {
    padding: 15px 0;
    height: 350px;
    overflow: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    /deep/ {
      .el-checkbox {
        padding: 0 15px;
      }
    }
  }
</style>

<style lang="scss">
  .limit-width {
    width: 100%;
    /deep/ {
      .el-form-item__content,
      .form-error,
      .transfer-wrapper,
      .transfer__right,
      .transfer__table,
      .base-table__wrapper {
        width: 100%;
      }
    }
  }
</style>
